import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { removeToast } from './actions';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { getToasts } from './reducers';
import Toast from './components/Toast';
import './styles.css';

export class Toasters extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.timers = {};
    props.toasts.forEach(this.updateTimers);
  }

  updateTimers = toast => {
    this.timers[toast.id] = setTimeout(() => {
      this.props.remove(toast);
      delete this.timers[toast.id];
    }, this.props.timeout || 5000);
  };

  handleClose = toast => {
    clearTimeout(this.timers[toast.id]);
    delete this.timers[toast.id];
    this.props.remove(toast);
  };

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    Object.keys(this.timers).forEach(key => clearTimeout(this.timers[key]));
    delete this.timers;
    document.body.removeChild(this.el);
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    return {
      toasts: this.props.toasts.filter(v => !prevProps.toasts.includes(v)),
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    snapshot.toasts.forEach(this.updateTimers);
  }

  render() {
    const { toasts, hasClose } = this.props;

    return ReactDOM.createPortal(
      <TransitionGroup className="mnd-toaster" appear={true}>
        {toasts.map(toast => (
          <CSSTransition
            key={toast.id}
            timeout={250}
            classNames="mnd-toaster__item"
          >
            <Toast
              classNames="mnd-toaster__item"
              message={toast.message}
              type={toast.type}
              onClose={hasClose ? () => this.handleClose(toast) : undefined}
            />
          </CSSTransition>
        ))}
      </TransitionGroup>,
      this.el,
    );
  }
}

export default connect(
  state => ({
    toasts: getToasts(state),
  }),
  dispatch => ({
    remove: toast => dispatch(removeToast(toast)),
  }),
)(Toasters);
